import { CreditCard, PaymentMethod } from 'deposit/services/deposit-service';

import { useCreditCard } from 'common/modules/payment-methods/@components/credit-card/credit-card.hook';

import { setPaymentMethod } from '../store/deposit';
import { useAppDispatch } from './hooks';

export const filterValidPaymentMethods = (paymentMethods: PaymentMethod[]) =>
  paymentMethods.filter((pm) => pm.status.active);

export const findAndSetPaymentMethod = (
  paymentMethods: PaymentMethod[] | [],
  code: string | undefined,
  tryPayByFlow: boolean,
  dispatch: ReturnType<typeof useAppDispatch>,
  onUseCreditCard: ReturnType<typeof useCreditCard>,
  paymentElements?: CreditCard[],
) => {
  const pm = paymentMethods.find((paymentMethod: PaymentMethod) => paymentMethod.code === code);
  dispatch(setPaymentMethod(pm));

  if (pm && onUseCreditCard.isValidVgsFlow(pm)) {
    onUseCreditCard.onSetInitCreditCards(paymentElements);
  }

  //Check if Payby is enabled for the selected PM
  if (tryPayByFlow && !pm?.payByAstropay) {
    return;
  }

  return pm;
};
